import firebase from 'firebase';

import config from '../config';

firebase.initializeApp(config.server);
const firestore = firebase.firestore();
firestore.settings({});
